import { pollUserActionService } from "@checkout/states/Cart/CartFulfill/services/pollUserAction";
import { getObjectKeysAsObject } from "@hopper-b2b/checkout";
import { pollFulfillService } from "./pollFulfill";
import { scheduleFulfillService } from "./scheduleFulfill";

export const services = {
  scheduleFulfillService,
  pollFulfillService,
  pollUserActionService,
};

export const ServiceTypes = getObjectKeysAsObject(services);
